import React, { useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import { sortByAlpha } from '../../helpers/sorters';
import ManageRolesByUser from './permissions-page/ManageRolesByUser';
import ManageTemplates from './permissions-page/ManageTemplates';

const PermissionsPage = () => {
  const { data } = useLoaderData();
  const { containers } = data;
  const [users, setUsers] = useState(data.users);
  const [externals, setExternals] = useState(data.external_users);
  const [templates, setTemplates] = useState(data.templates);
  const sortedContainers = sortByAlpha(containers, 'name');
  const sortedTemplates = sortByAlpha(templates, 'name');
  const nonAdminUsers = sortByAlpha(
    users.filter((u) => !u.admin),
    'name'
  );
  const nonAdminExternals = sortByAlpha(
    externals.filter((u) => !u.admin),
    'name'
  );

  const updateUsersState = (id, model, roles) => {
    if (model == 'user') {
      setUsers((users) => {
        let updatedUser = { ...users.find((u) => u.id == id) };
        updatedUser.roles = roles;
        return [...users.filter((u) => u.id != id), updatedUser];
      });
    } else if (model == 'external_user') {
      setExternals((externals) => {
        let updatedUser = { ...externals.find((e) => e.id == id) };
        updatedUser.roles = roles;
        return [...externals.filter((e) => e.id != id), updatedUser];
      });
    }
  };

  const updateTemplateState = (updatedTemplates) => {
    setTemplates(sortByAlpha(updatedTemplates, 'name'));
  };

  const removeUserFromState = (id) => {
    setUsers([...users.filter((u) => u.id != id)]);
  };

  return (
    <div className='manage-permissions'>
      <header>
        <div className='breadcrumbs'>
          <ol>
            <li className='right'>
              <a href='/manage/external_users'>
                Go to Test Users <i className='fa-solid fa-arrow-right' />
              </a>
            </li>
          </ol>
        </div>
      </header>
      <ManageRolesByUser
        users={nonAdminUsers}
        externals={nonAdminExternals}
        containers={sortedContainers}
        updateUsersState={updateUsersState}
        templates={sortedTemplates}
        updateTemplateState={updateTemplateState}
        removeUserFromState={removeUserFromState}
      />
      <hr />
      <ManageTemplates
        templates={sortedTemplates}
        containers={sortedContainers}
        updateTemplateState={updateTemplateState}
      />
    </div>
  );
};

export default PermissionsPage;
